module.exports = __webpack_public_path__ + "phone_desktop_link.png?6981ad0ee851a941bef7b260bdc6ef7b";